module.exports = __webpack_public_path__ + "static/media/cross.e4f5bf90.svg";